import { render, staticRenderFns } from "./ProcessPayroll.vue?vue&type=template&id=6af1072f&scoped=true"
import script from "./ProcessPayroll.vue?vue&type=script&lang=js"
export * from "./ProcessPayroll.vue?vue&type=script&lang=js"
import style0 from "./ProcessPayroll.vue?vue&type=style&index=0&id=6af1072f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af1072f",
  null
  
)

export default component.exports